import React, { useMemo } from 'react';
import classNames from 'classnames';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import { WorkOrder } from '../../types';
import classes from './style.module.scss';
import { formatWorkOrderDateRange } from '../../helper';
import LinkWrapper from '~/app/common/LinkWrapper';
import { route } from '~/app/helpers/route';
import { WORKORDER_ROUTES } from '~/workorder/Router';

export interface ListItemProps {
    item: WorkOrder
    listClassName?: string
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({ item, listClassName }) => {
    const { t } = useTranslation('workorder');

    const title = useMemo(() => {
        const parts = [item.machineIntern, item.machineName].filter(Boolean);
        return parts.join(' - ');
    }, [item.machineIntern, item.machineName]);

    const dateRange = useMemo(() => {
        return formatWorkOrderDateRange(item.workOrderStartDate, item.workOrderEndDate)
    }, [item.workOrderStartDate, item.workOrderEndDate]);

    const statusClass = `status-${item.status}`;

    return (
        <LinkWrapper to={route(WORKORDER_ROUTES.detail, { id: item.id})}>
            <div className={classNames(classes['list-item'], listClassName && classes[listClassName])}>
                <div className={classes['header']}>
                    <span className={classes['work-order-no']}>{item.workOrderNo}</span>
                    <span className={classNames(classes['status'], classes[statusClass])}>
                        {t(`statuses.${item.status}`)}
                    </span>
                </div>
                <div className={classes['title']}>{title}</div>
                <div className={classes['meta']}>
                    {item.responsible && (
                        <span className={classes['meta-item']}>
                            <Icon name="person" size={14} className={classes['meta-icon']} />
                            <span className={classes['meta-text']}>{item.responsible}</span>
                        </span>
                    )}
                    {dateRange && (
                        <span className={classes['meta-item']}>
                            <Icon name="calendar_today" size={14} className={classes['meta-icon']} />
                            <span className={classes['meta-text']}>{dateRange}</span>
                        </span>
                    )}
                    <span className={classes['meta-item']}>
                        <Icon name="build" size={14} className={classes['meta-icon']} />
                        <span className={classes['meta-text']}>{ t(item.issueCount === 1 ? 'issueCount_one' : 'issueCount_other', { count: item.issueCount })}</span>

                    </span>
                </div>
            </div>
        </LinkWrapper>
    );
};

export default ListItem;
